import type { Cng, Owner } from '../types/domain';
import { images } from './images';

export const workflowStages = [
  { key: 'entry', label: 'ডাটা এন্ট্রি', en: 'Data Entry' },
  { key: 'validation', label: 'তথ্য যাচাই', en: 'Data Validation' },
  { key: 'review', label: 'কর্মকর্তা পর্যালোচনা', en: 'Officer Review' },
  { key: 'approval', label: 'অনুমোদন', en: 'Approval' },
  { key: 'qr', label: 'QR তৈরি', en: 'QR Generation' },
  { key: 'print', label: 'স্টিকার প্রিন্ট', en: 'Sticker Printing' },
  { key: 'issue', label: 'স্টিকার ইস্যু', en: 'Sticker Issuance' },
  { key: 'active', label: 'সক্রিয়', en: 'Active' }
];

export const trafficDivisions = ['রমনা', 'লালবাগ', 'মতিঝিল', 'ওয়ারী', 'তেজগাঁও', 'মিরপুর', 'গুলশান', 'উত্তরা'];

function owner(name: string, father: string, nid: string, mobile: string, address: string, photo?: string): Owner {
  return {
    name,
    father,
    nid,
    nidMasked: nid.slice(0, 6) + 'XXXXXX',
    mobile,
    mobileMasked: mobile.slice(0, 6) + 'XXX' + mobile.slice(-3),
    address,
    status: 'সক্রিয়',
    photo
  };
}

const base = {
  type: 'সিএনজি অটোরিকশা',
  model: 'বাজাজ RE 4S (CNG)',
  color: 'সবুজ',
  fitness: 'বৈধ',
  taxToken: 'বৈধ',
  routePermit: 'ঢাকা মহানগর'
};

export const cngs: Cng[] = [
  {
    ...base,
    id: 'c1',
    reg: 'ঢাকা-থ-১১-১২৩৪',
    chassis: 'MDH12F45ABC123456',
    engine: 'ENG987654321',
    year: '২০২১',
    brtaRegDate: '১২ জানুয়ারি ২০২২',
    fitnessExpiry: '৩০ জুন ২০২৭',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000001',
    owner: owner('মোঃ রহিম উদ্দিন', 'মৃত আব্দুল করিম', '1987654321098', '01712-345678', 'বাড়ি ২৮, রোড ৩, সেকশন ১০, মিরপুর, ঢাকা-১২১৬', images.owner),
    driverIds: ['d1', 'd2', 'd3'],
    brtaStatus: 'যাচাইকৃত',
    division: 'মিরপুর',
    stage: 7,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-001',
    approvedOn: '০২ মার্চ ২০২৬'
  },
  {
    ...base,
    id: 'c2',
    reg: 'ঢাকা-থ-১১-৫৬৭৮',
    chassis: 'MDH12F45ABC567890',
    engine: 'ENG123450987',
    year: '২০২২',
    brtaRegDate: '০৪ মে ২০২২',
    fitnessExpiry: '১৫ আগস্ট ২০২৭',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000002',
    owner: owner('মোঃ হাসান আলী', 'মোঃ মোবারক আলী', '1979345678123', '01819-456789', 'বাড়ি ৯, উত্তর বাড্ডা, গুলশান, ঢাকা-১২১২'),
    driverIds: ['d4', 'd5'],
    brtaStatus: 'যাচাইকৃত',
    division: 'গুলশান',
    stage: 3,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-001'
  },
  {
    ...base,
    id: 'c3',
    reg: 'ঢাকা-থ-১২-৩৪৫৬',
    chassis: 'MDH12F45ABD345612',
    engine: 'ENG554433221',
    year: '২০২০',
    brtaRegDate: '২০ সেপ্টেম্বর ২০২০',
    fitnessExpiry: '১০ নভেম্বর ২০২৬',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000003',
    owner: owner('মোঃ আব্দুল মালেক', 'মৃত আব্দুল হামিদ', '1975123498765', '01711-765432', 'তেজকুনিপাড়া, তেজগাঁও, ঢাকা-১২১৫'),
    driverIds: ['d6'],
    brtaStatus: 'যাচাইকৃত',
    division: 'তেজগাঁও',
    stage: 7,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-001',
    approvedOn: '২৮ ফেব্রুয়ারি ২০২৬'
  },
  {
    ...base,
    id: 'c4',
    reg: 'ঢাকা-থ-১৩-৭৮৯০',
    chassis: 'MDH12F45ABE789034',
    engine: 'ENG667788990',
    year: '২০১৯',
    brtaRegDate: '১১ মার্চ ২০১৯',
    fitness: 'মেয়াদোত্তীর্ণ',
    fitnessExpiry: '১০ মার্চ ২০২৬',
    taxExpiry: '৩১ ডিসেম্বর ২০২৫',
    taxToken: 'মেয়াদোত্তীর্ণ',
    qrId: 'CNG-000004',
    owner: owner('মোসাঃ শাহনাজ বেগম', 'মোঃ আজিজুল হক', '1982765432109', '01552-112233', 'সেগুনবাগিচা, রমনা, ঢাকা-১০০০'),
    driverIds: ['d7'],
    brtaStatus: 'অমিল',
    division: 'রমনা',
    stage: 1,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-002',
    mismatches: [
      { label: 'ফিটনেস মেয়াদ', brta: '১০ মার্চ ২০২৬', dmp: '১০ মার্চ ২০২৭' },
      { label: 'ড্রাইভিং লাইসেন্স', brta: 'BRTA-1122334 (মেয়াদোত্তীর্ণ)', dmp: 'BRTA-1122334 (সক্রিয়)' }
    ]
  },
  {
    ...base,
    id: 'c5',
    reg: 'ঢাকা-থ-১১-২৪৬৮',
    chassis: 'MDH12F45ABF246801',
    engine: 'ENG908172635',
    year: '২০২২',
    brtaRegDate: '১৮ জুলাই ২০২২',
    fitnessExpiry: '১৭ জুলাই ২০২৭',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000005',
    owner: owner('মোঃ জাকির হোসেন', 'মোঃ ইউনুস মিয়া', '1984567890123', '01914-778899', 'আজিমপুর, লালবাগ, ঢাকা-১২০৫'),
    driverIds: ['d9'],
    brtaStatus: 'যাচাইকৃত',
    division: 'লালবাগ',
    stage: 5,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-001',
    approvedOn: '১০ মার্চ ২০২৬'
  },
  {
    ...base,
    id: 'c6',
    reg: 'ঢাকা-থ-১৪-১৩৫৭',
    chassis: 'MDH12F45ABG135790',
    engine: 'ENG246813579',
    year: '২০২১',
    brtaRegDate: '০৯ ফেব্রুয়ারি ২০২১',
    fitnessExpiry: '০৮ ফেব্রুয়ারি ২০২৭',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000006',
    owner: owner('মোঃ মনির হোসেন', 'মোঃ কাদের মিয়া', '1981234567890', '01675-334455', 'টিকাটুলি, ওয়ারী, ঢাকা-১২০৩'),
    driverIds: ['d10'],
    brtaStatus: 'যাচাইকৃত',
    division: 'ওয়ারী',
    stage: 6,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-001',
    approvedOn: '০৮ মার্চ ২০২৬'
  },
  {
    ...base,
    id: 'c7',
    reg: 'ঢাকা-থ-১২-৮৬৪২',
    chassis: 'MDH12F45ABH864209',
    engine: 'ENG135792468',
    year: '২০২৩',
    brtaRegDate: '২২ জানুয়ারি ২০২৩',
    fitnessExpiry: '২১ জানুয়ারি ২০২৮',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000007',
    owner: owner('মোঃ সাইফুল ইসলাম', 'মোঃ নজরুল ইসলাম', '1990456789012', '01712-990011', 'সেক্টর ৭, উত্তরা, ঢাকা-১২৩০'),
    driverIds: ['d11'],
    brtaStatus: 'যাচাইকৃত',
    division: 'উত্তরা',
    stage: 4,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-001',
    approvedOn: '১১ মার্চ ২০২৬'
  },
  {
    ...base,
    id: 'c8',
    reg: 'ঢাকা-থ-১৫-৯৭৫৩',
    chassis: 'MDH12F45ABJ975310',
    engine: 'ENG112233445',
    year: '২০২২',
    brtaRegDate: '১৪ অক্টোবর ২০২২',
    fitnessExpiry: '১৩ অক্টোবর ২০২৭',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000008',
    owner: owner('মোঃ কামাল উদ্দিন', 'মোঃ জালাল উদ্দিন', '1978901234567', '01819-223344', 'আরামবাগ, মতিঝিল, ঢাকা-১০০০'),
    driverIds: ['d5'],
    brtaStatus: 'যাচাইকৃত',
    division: 'মতিঝিল',
    stage: 7,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-001',
    approvedOn: '০১ মার্চ ২০২৬'
  },
  {
    ...base,
    id: 'c9',
    reg: 'ঢাকা-থ-১৩-১১২২',
    chassis: 'MDH12F45ABK112298',
    engine: 'ENG556677889',
    year: '২০২০',
    brtaRegDate: '০৩ জুন ২০২০',
    fitnessExpiry: '০২ জুন ২০২৭',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000009',
    owner: owner('মোঃ ইউসুফ আলী', 'মোঃ রমজান আলী', '1983678901234', '01556-667788', 'শেওড়াপাড়া, মিরপুর, ঢাকা-১২১৬'),
    driverIds: ['d8'],
    brtaStatus: 'যাচাইকৃত',
    division: 'মিরপুর',
    stage: 2,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-002'
  },
  {
    ...base,
    id: 'c10',
    reg: 'ঢাকা-থ-১৪-২২১৯',
    chassis: 'MDH12F45ABL221977',
    engine: 'ENG778899001',
    year: '২০২১',
    brtaRegDate: '১৬ আগস্ট ২০২১',
    fitnessExpiry: '১৫ আগস্ট ২০২৭',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000010',
    owner: owner('মোঃ নজরুল ইসলাম', 'মৃত আব্দুস সাত্তার', '1980789012345', '01717-445566', 'নতুন বাজার, গুলশান, ঢাকা-১২১২'),
    driverIds: ['d4'],
    brtaStatus: 'অমিল',
    division: 'গুলশান',
    stage: 1,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-002',
    mismatches: [
      { label: 'মালিকের নাম', brta: 'মোঃ নজরুল ইসলাম', dmp: 'মোঃ নজরুল ইসলাম খান' },
      { label: 'ইঞ্জিন নং', brta: 'ENG778899001', dmp: 'ENG778899010' }
    ]
  },
  {
    ...base,
    id: 'c11',
    reg: 'ঢাকা-থ-১১-৩৩৪৪',
    chassis: 'MDH12F45ABM334455',
    engine: 'ENG990011223',
    year: '২০২২',
    brtaRegDate: '২৭ মার্চ ২০২২',
    fitnessExpiry: '২৬ মার্চ ২০২৭',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000011',
    owner: owner('মোঃ হাবিবুর রহমান', 'মোঃ আতাউর রহমান', '1977890123456', '01913-556677', 'কারওয়ান বাজার, তেজগাঁও, ঢাকা-১২১৫'),
    driverIds: ['d6'],
    brtaStatus: 'যাচাইকৃত',
    division: 'তেজগাঁও',
    stage: 7,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-001',
    approvedOn: '০৫ মার্চ ২০২৬'
  },
  {
    ...base,
    id: 'c12',
    reg: 'ঢাকা-থ-১২-৫৫৬৬',
    chassis: 'MDH12F45ABN556677',
    engine: 'ENG334455667',
    year: '২০২৩',
    brtaRegDate: '০৫ নভেম্বর ২০২৩',
    fitnessExpiry: '০৪ নভেম্বর ২০২৮',
    taxExpiry: '৩১ ডিসেম্বর ২০২৬',
    qrId: 'CNG-000012',
    owner: owner('মোঃ শফিকুল আলম', 'মোঃ মকবুল হোসেন', '1986012345678', '01818-778800', 'রূপনগর, মিরপুর, ঢাকা-১২১৬'),
    driverIds: ['d9'],
    brtaStatus: 'অপেক্ষমাণ',
    division: 'মিরপুর',
    stage: 0,
    source: 'ম্যানুয়াল এন্ট্রি'
  },
  {
    id: 'c13',
    type: 'ব্যাটারিচালিত অটোরিকশা',
    model: 'ইজিবাইক ৫-সিটার (লেড-এসিড)',
    color: 'নীল-সাদা',
    fitness: 'বৈধ',
    taxToken: 'প্রযোজ্য নয়',
    routePermit: 'মিরপুর-কল্যাণপুর-গাবতলী',
    reg: 'ঢাউসিক-অটো-০৮-৪৫২১',
    chassis: 'EZB-LX-2024-77812',
    engine: 'MTR-BLDC-1000-55821',
    year: '২০২৪',
    brtaRegDate: '০৩ মার্চ ২০২৪',
    fitnessExpiry: '৩০ জুন ২০২৬',
    taxExpiry: '—',
    qrId: 'ATR-000001',
    owner: owner('মোঃ জসিম উদ্দিন', 'মোঃ রফিক উদ্দিন', '1988123409876', '01716-224466', 'দারুস সালাম রোড, মিরপুর-১, ঢাকা-১২১৬'),
    driverIds: ['d7', 'd8'],
    brtaStatus: 'যাচাইকৃত',
    division: 'মিরপুর',
    stage: 7,
    source: 'ম্যানুয়াল এন্ট্রি',
    approvedOn: '০৮ মার্চ ২০২৬'
  },
  {
    id: 'c14',
    type: 'মোটরসাইকেল',
    model: 'বাজাজ পালসার N160',
    color: 'কালো',
    fitness: 'প্রযোজ্য নয়',
    taxToken: 'বৈধ',
    routePermit: 'রাইড শেয়ারিং — পাঠাও',
    reg: 'ঢাকা মেট্রো-হ-৩৪-৫৬৭৮',
    chassis: 'MD2A11CZ6PCH45612',
    engine: 'DHZWPC45612',
    year: '২০২৩',
    brtaRegDate: '১৮ সেপ্টেম্বর ২০২৩',
    fitnessExpiry: '—',
    taxExpiry: '১৭ সেপ্টেম্বর ২০২৬',
    qrId: 'MCL-000001',
    owner: owner('মোঃ তানভীর আহমেদ', 'মোঃ মোস্তফা কামাল', '1995456712309', '01815-907812', 'শেওড়াপাড়া, মিরপুর, ঢাকা-১২১৬'),
    driverIds: ['d9'],
    brtaStatus: 'যাচাইকৃত',
    division: 'তেজগাঁও',
    stage: 3,
    source: 'BRTA আমদানি',
    importBatch: 'BRTA-IMP-2026-001'
  },
  {
    id: 'c15',
    type: 'মোটরসাইকেল',
    model: 'Yamaha FZS V3',
    color: 'কালো',
    fitness: 'প্রযোজ্য নয়',
    taxToken: 'বৈধ',
    routePermit: 'প্রযোজ্য নয়',
    reg: 'ঢাকা মেট্রো-ল-৪৫-৬৭৮৯',
    chassis: 'ME1RG1234K0005678',
    engine: 'G3J3E0098765',
    year: '২০২৩',
    brtaRegDate: '০৮ মার্চ ২০২৩',
    fitnessExpiry: '—',
    taxExpiry: '২০ ফেব্রুয়ারি ২০২৭',
    qrId: 'DMP-MCL-000002',
    owner: owner('মোঃ রহিম উদ্দিন', 'মৃত আব্দুল করিম', '1987654321098', '01712-345678', 'বাড়ি ২৮, রোড ৩, সেকশন ১০, মিরপুর, ঢাকা-১২১৬', images.owner),
    driverIds: [],
    brtaStatus: 'যাচাইকৃত',
    division: 'মিরপুর',
    stage: 2,
    source: 'মালিক স্ব-নিবন্ধন'
  }
];
